import { Grid, FormControl, RadioGroup, FormControlLabel, Radio, withStyles } from '@material-ui/core';
import { green, red, yellow } from '@material-ui/core/colors';
import { useContext, useEffect, useState } from 'react';
import { FirebaseContext } from '../firebase/context';
import AceEditor from 'react-ace';
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-min-noconflict/mode-javascript"
import { useParams } from 'react-router-dom';


const AnswerPage = ({ classes, steps, user }) => {
    const [stepsWithAnswers, setStepsWithAnwers] = useState([]);
    const firebase = useContext(FirebaseContext)
    const [selectedUser, setSelectedUser] = useState();
    const params = useParams();
    const [score, setScore] = useState(0)

    useEffect(() => {
        setSelectedUser(user);
        getAnswers()
        getCorrectAnswers()
    }, [])

    useEffect(() => {
        setSelectedUser(user)
        if (selectedUser) {
            getAnswers()
        }
    }, [user])

    const getAnswers = () => {
        const db = firebase.firestore()

        if (user) {
            db.collection('answers').where("uid", "==", user.uid).get().then(q => {
                const answers = q.docs.map(doc => Object.assign({ step: doc.id.split("-")[1] }, doc.data()))
                let updatedSteps = steps.map(step=>{
                    step.answer = '';
                    return step;
                })
                


                answers.forEach(answer => {
                    updatedSteps[answer.step].answer = answer.value
                    updatedSteps[answer.step].score = answer.score || '';
                })

                setStepsWithAnwers(updatedSteps)
                updateScore(updatedSteps)
            });
        }
    }

    const getCorrectAnswers = () => {
        const db = firebase.firestore();
            db.collection('answers').where("uid", "==", "answer").get().then(q => {
                const answers = q.docs.map(doc => Object.assign({ step: doc.id.split("-")[1] }, doc.data()))
                let updatedSteps = steps.map(step=>{
                    step.correctAnswer = '';
                    return step;
                })
                
                answers.forEach(answer => {
                    updatedSteps[answer.step].correctAnswer = answer.value
                })

                setStepsWithAnwers(updatedSteps)
            });
    }

    const saveScore = (uid, step, value) => {
        const db = firebase.firestore();
        const answerKey = `${uid}-${step}`;

        const docRef = db.collection('answers').doc(answerKey).set({
            score: value,
            uid, uid
        }, { merge: true }).then(res => {
            //update locally so score can update
            stepsWithAnswers[step].score = value;
            setStepsWithAnwers(stepsWithAnswers)
            
            updateScore(stepsWithAnswers);
        })
    }

    const updateScore = (steps)=>{

        const scoring = {
            correct: 1,
            partial: .5,
            wrong: 0
        }

        const score = steps.reduce((accum, step)=>{
            const stepScore = step.score ? scoring[step.score] : 0;
            return accum + stepScore
        },0)

        setScore(score);
    }

    const getTotalPossible = ()=>{
        const applicableSteps = stepsWithAnswers.filter(step=>step.role.indexOf(params.role || 'se') > -1)
        const totalPossible = applicableSteps.length -1 //remove welcome step
        return totalPossible;
    }

    const GreenRadio = withStyles({
        root: {
            color: green[400],
            '&$checked': {
                color: green[600],
            },
        },
        checked: {},
    })((props) => <Radio color="default" {...props} />);

    const RedRadio = withStyles({
        root: {
            color: red[400],
            '&$checked': {
                color: red[600],
            },
        },
        checked: {},
    })((props) => <Radio color="default" {...props} />);

    const YellowRadio = withStyles({
        root: {
            color: yellow[700],
            '&$checked': {
                color: yellow[800],
            },
        },
        checked: {},
    })((props) => <Radio color="default" {...props} />);

    const Score = ({ uid, step, score }) => {
        return (
            <FormControl component="fieldset" style={{ justifyContent: 'center' }}>
                <RadioGroup row aria-label="position" name="position" defaultValue={score} onChange={(e) => {saveScore(uid, step, e.target.value)}}>
                    <FormControlLabel
                        value="wrong"
                        control={<RedRadio />}
                        label="Incorrect"
                        labelPlacement="start"
                    />
                    <FormControlLabel
                        value="partial"
                        control={<YellowRadio />}
                        label="Partial"
                        labelPlacement="start"
                    />
                    <FormControlLabel
                        value="correct"
                        control={<GreenRadio />}
                        label="Correct"
                        labelPlacement="start"
                    />
                </RadioGroup>
            </FormControl>
        )
    }

    const AnswerDisplay = ({ type, codeString }) => {
        let input;
        if (type === "code") {
            input = <AceEditor
                mode="javascript" // in the future this might be variable if the exercis takes other languages
                theme="monokai"
                width="100%"
                showPrintMargin={false}
                defaultValue={codeString}
                readOnly={true} //TODO: if this is the tutorial step, or if the active user doesn't match the selected user, disable
                value={codeString}
                setOptions={{ useWorker: false }}
            />
        } else {
            input = <textarea
                style={{ width: "100%", height: "400px" }}
                value={codeString}
                readOnly={true}
            />
        }

        return input;

    }

    return (
        <div>
            <h3>Score: {score}/{getTotalPossible()}</h3>
            {
                stepsWithAnswers.map((step, index) => {
                    if(index > 0){
                        return (
                            <Grid container spacing={2} justify="center" className={classes.bodyContent} style={{ marginBottom: 50 }} key={index}>
                                <Grid item xs={12} md={12}>
                                    <div style={{ display: 'flex' }}>
                                        <h2 style={{ textAlign: 'left' }}>{step.title} - </h2>
                                        <Score score={step.score} uid={selectedUser.uid} step={index} />
                                    </div>
                                </Grid>
                                <Grid item xs={6} md={6}>
                                    <h4 style={{ textAlign: 'left', margin: 0 }}>Response:</h4>
                                    <AnswerDisplay type={step.type} codeString={step.answer} />
                                </Grid>
                                <Grid item xs={6} md={6}>
                                    <h4 style={{ textAlign: 'left', margin: 0 }}>Correct Answer:</h4>
                                    <AnswerDisplay type={step.type} codeString={step.correctAnswer} />
                                </Grid>
                            </Grid>
                        )
                    }
                    return ''
                })
            }
        </div>
    )
}

export default AnswerPage;